import { NoteFailedClientErrorCode } from '@/models/analytics/contracts/note-failed-error-code';

export class EmptyNoteStreamError extends Error {
  constructor() {
    super(NoteFailedClientErrorCode.EmptyNoteStream);
    this.name = 'EmptyNoteStreamError';
  }
}
